import React, { useCallback } from 'react';
import SelectV2 from '../../Select/SelectV2';
import ComponentPropTypes from './ComponentPropTypes';

/**
 *
 * @typedef {object} OptionsComponentProperties
 * @property {boolean} isClearable
 * @property {boolean} isMultiple
 * @property {string} direction
 * @property {string} iteratee
 * @property {boolean} isLoading
 *
 * @typedef {object} OptionsComponentModel
 * @property {string} type
 * @property {string} placeholder
 * @property {boolean} disabled
 * @property {boolean} isRequired
 * @property {string} path
 * @property {object[]} options
 * @property {OptionsComponentProperties} properties
 */

/**
 * @param {OptionsComponentModel} model
 * @param value
 * @param onChange
 * @param hasError
 * @returns {JSX.Element}
*/
const OptionsComponentV2 = ({ model, value, onChange, hasError }) => {
  const _onChange = useCallback(newValue => onChange(model, newValue), [model, onChange]);

  return (<SelectV2
    onChange={_onChange}
    isClearable={model.properties?.isClearable}
    isMultiple={model.properties?.isMultiple}
    isTypeahead={model.properties?.isTypeahead}
    isDisabled={model?.disabled}
    placeholder={model.placeholder}
    options={model.options}
    direction={model.properties?.direction}
    value={value}
    validated={hasError ? 'error' : 'default'}
    iteratee={model.properties?.iteratee}
    isLoading={model.properties?.isLoading || false}
  />);
};

OptionsComponentV2.propTypes = ComponentPropTypes;

export default OptionsComponentV2;
